"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.OptionsActions = void 0;

/**
 * Actions have a type that where the name will show up in logs.
 */
var OptionsActions;
exports.OptionsActions = OptionsActions;

(function (OptionsActions) {
  OptionsActions["showOptions"] = "@app/options/show";
  OptionsActions["getThemes"] = "@app/options/themes/list";
  OptionsActions["changeTheme"] = "@app/options/theme/change";
  OptionsActions["showHelp"] = "@app/options/help/show";
})(OptionsActions || (exports.OptionsActions = OptionsActions = {}));